import api from "../../api/api";


const getBySection = (section) =>{
    return new Promise((resolve, reject)=>{
        api.get("/print-setting/"+section).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg,
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}

const save = (data) =>{
    return new Promise((resolve, reject)=>{
        api.post("/print-setting",data).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :res.data.msg,
                })
            }
          }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
          })
    })
}




const printSettingServices = {
    getBySection,
    save,
}
export default printSettingServices;